import { withCurrentUser } from '@/shared/authentication';
import UserSelector from './user-selector.vue';
export default withCurrentUser(UserSelector);
